import { DataTable } from './DataTable'
import { Button, message, Upload } from 'antd'
import { YhBox } from '@/components/YhBox'
import { baseDriverModel } from '../driverModel'
import { UserDeleteOutlined, UserAddOutlined } from '@ant-design/icons'
import useGlobalModel from '@/model/globalModel'
import { importPropsConfig, messageConfig } from '@/utils/importFile'

export const DataBox = () => {
    const { setAddCarVisible, onDelete, loadData, initPgCfg, selectedRowKeys, downloadMB } = baseDriverModel()
    const {
        user: { shopCode },
        setLoadingInfo,
    } = useGlobalModel()

    const upLoadCallback = (retData: any) => {
        if (!retData) {
            setLoadingInfo({ loadingVisible: false, txt: '' })
            return message.warning('数据异常，请尝试重新导入')
        } else {
            messageConfig(retData, 30, 'info')
            loadData(initPgCfg, {})
            return setLoadingInfo({ loadingVisible: false, txt: '' })
        }
    }
    const action = (
        <>
            <Button shape="round" type="primary" onClick={() => setAddCarVisible(true)}>
                <UserAddOutlined />
                添加司机
            </Button>
            <Button
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        return message.warning('请选择司机进行删除功能！')
                    } else {
                        onDelete(selectedRowKeys)
                    }
                }}
            >
                <UserDeleteOutlined />
                一键删除
            </Button>
            <Button className="mr-5" type="link" shape="round" onClick={() => downloadMB()}>
                下载模板
            </Button>
            <Upload
                showUploadList={false}
                className="mr-10 ml-10"
                {...importPropsConfig(
                    `/threeInspection/base/driver/import`,
                    upLoadCallback,
                    () => setLoadingInfo({ loadingVisible: true, txt: '快速导入中' }),
                    { type: '司机', createUserId: shopCode },
                    false,
                )}
            >
                <Button className="mr-5" type="link" shape="round">
                    {' '}
                    导入{' '}
                </Button>
            </Upload>
        </>
    )

    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}
